import { Vue } from 'vue-property-decorator';
export default class APP_CONST extends Vue {



  /**
   * A collection of application features with their corresponding feature flag key.
   */
  public static readonly FEATURE_KEYS = {
    customPayments: 'custom-payments',
    automaticDiscounts: 'automatic-discounts',
  } as const;


  /**
   * A collection of segment events with their corresponding event key.
   */
  public static readonly SEGMENT_EVENTS = {
    PRODUCT_CATALOG: {
      catalogViewed: 'Catalog Viewed',
      catalogFilteredByProgram: 'Catalog Filtered by Program',
      catalogFilteredByLocation: 'Catalog Filtered by Location',
      catalogFilteredBySessionDates: 'Catalog Filtered by Session Dates',
      catalogFiltersCleared: 'Catalog Filters Cleared',
      addChildInCatalogView: 'Add Children in Catalog View',
      addSessionToCart: 'Add Session to Cart',
    },
    SHOPPING_CART_REVIEW: {
      reviewViewCart: 'Review View Cart',
      addChildrenInCart: 'Add Children in Cart View',
      removeSessionFromCart: 'Remove Session from Cart',
      viewCatalogFromCart: 'View Catalog from Cart',
      reviewChildSelection: 'Review View Child Selection',
    },
    SHOPPING_CART_APPLICATION: {
      cartAddNewChild: 'Cart Add New Child',
      cartSelectExistingChild: 'Cart Select Existing Child',
      applyViewChildApplication: 'Apply View Child Application',
      applicationViewCart: 'Application View Cart',
      applyViewChildSelection: 'Apply View Child Selection',
      applicationFormFilled: 'Application Form Filled',
      viewPaymentScreen: 'View Payment Screen'
    },
    SHOPPING_CART_SUBMIT: {
      applyPromoCode: 'Apply Promo Code',
      submitOrder: 'Submit Order',
      submitViewChildApplication: 'Submit View Child Application',
      enterPromoCode: 'Enter Promo Code',
    },
    CHECKOUT_COMPLETE: { checkoutComplete: 'Checkout Complete' },
    PROFILE: {
      viewedProfile: 'Profile Viewed',
      editedProfile: 'Edit Profile',
      changePassword: 'Change Password',
    },
    DASHBOARD: {
      viewFamilyPortal: 'View Family Portal'
    },
    SCHOLAR_DETAILS: {
      viewedScholarDetails: 'Viewed Scholar Details',
      addedGuardian: 'Added Guardian',
      deletedGuardian: 'Deleted Guardian',
      addedEmergencyContact: 'Added Emergency Contact',
      deletedEmergencyContact: 'Deleted Emergency Contact',
      editedScholarDetails: 'Edited Scholar Details',
      saveScholarChanges: 'Save Scholar Changes',
    },
    SCHOLAR_PROGRAMS: {
      viewedScholarPrograms: 'Viewed Scholar Programs',
      addAuthorizedPickup: 'Add Authorized Pickup',
      deleteAuthorizedPickup: 'Delete Authorized Pickup',
    },
    SCHOLAR_DOCUMENTS: {
      viewedScholarDocuments: 'Viewed Scholar Documents',
      uploadDocument: 'Upload Scholar Documents',
    },
    SIGN_UP: { viewedSignUp: 'Viewed SignUp'},
    REGISTER: { register: 'Register' },
    LOGIN: { login: 'Login' },
  } as const;

  public static readonly APP_ROUTES = {
    PROGRAMS: { name: 'Programs', path: '/programs' },
    CHECKOUT: { name: 'Checkout', path: '/programs/checkout' },
    CHECKOUT_REVIEW: { name: 'Checkout Review', path: '/programs/checkout/review' },
    CHECKOUT_APPLY: { name: 'Checkout Apply', path: '/programs/checkout/apply' },
    CHECKOUT_SUBMIT: { name: 'Checkout Submit', path: '/programs/checkout/submit' },
    CHECKOUT_DONE: { name: 'Checkout Done', path: '/programs/checkout/done' },
    REGISTER: { name: 'Register', path: '/register' },
    LOGIN: { name: 'Login', path: '/login' },
    SIGNIN: { name: 'SignIn', path: '/signin' },
    SIGNUP: { name: 'SignUp', path: '/signup' },
    RESETPASSWORD: { name: 'Reset Password', path: '/resetpassword' },
    DASHBOARD: { name: 'Dashboard', path: '/dashboard' },
    FAMILY_PORTAL: { name: 'Family Portal', path: '/' },
    APPLICATION_EMPTY_STATE: { name: 'applicationemptystate', path: '/applicationemptystate' },
    PAGE_NOT_FOUND: { name: 'Page Not Found', path: '/pagenotfound' },
    MANAGE_SCHOLAR: { name: 'Manage Scholar', path: '/scholar' },
    SCHOLAR_DETAILS: { name: 'Scholar Details', path: '/scholar/details' },
    SCHOLAR_PROGRAMS: { name: 'Scholar Programs', path: '/scholar/programs' },
    SCHOLAR_DOCUMENTS: { name: 'Scholar Documents', path: '/scholar/documents' },
    USER_PROFILE: { name: 'User Profile', path: '/user/profile' },
    NO_LONGER_AVAILABLE: { name: 'No Longer Avaliable', path: '/nolongeraccess' },
    MANAGE_APPLICATION: { name: 'Manage Application', path: '/application' },
    APPLICATION_FORMS: { name: 'Application Forms', path: '/application/forms' },
    APPLICATION_UPLOAD_DOCUMENTS: { name: 'Upload Documents', path: '/application/upload/documents' }
  };
  public static readonly CART_APPLICATION_VALIDATION_TRIGGER_EVENT = 'CART_APPLICATION_VALIDATION_TRIGGER_EVENT';
  public static readonly CART_APPLICATION_VALIDATION_RAN_EVENT = 'CART_APPLICATION_VALIDATION_RAN_EVENT';
  public static readonly CART_APPLICATION_SAVE_APPLICATION_FORMS_TRIGGER_EVENT = 'CART_APPLICATION_SAVE_APPLICATION_FORMS_TRIGGER_EVENT';
  public static readonly CART_APPLICATION_SCHOLAR_FN_LN_DOB_CHANGED_TRIGGER_EVENT = 'CART_APPLICATION_SCHOLAR_FN_LN_DOB_CHANGED_TRIGGER_EVENT';
  public static readonly CART_APPLICATION_SCHOLAR_BIRTHDATE_CHANGED_TRIGGER_EVENT = 'CART_APPLICATION_SCHOLAR_BIRTHDATE_CHANGED_TRIGGER_EVENT';
  public static readonly CART_IS_RELOADING_EVENT = 'CART_IS_RELOADING_EVENT';
  public static readonly CART_APPLICATION_RESET_SCHOLAR_BIRTHDATE_TRIGGER_EVENT = 'CART_APPLICATION_RESET_SCHOLAR_BIRTHDATE_TRIGGER_EVENT';
  public static readonly CART_APPLICATION_RESET_SCHOLAR_TRIGGER_EVENT = 'CART_APPLICATION_RESET_SCHOLAR_TRIGGER_EVENT';
  public static readonly CART_LOCAL_STORAGE_KEY = 'LOCAL_STORAGE_CART_MAP';

  public static readonly LANGUAGE_ENGLISH = 'en';
  public static readonly LANGUAGE_SPANISH = 'es';
  public static readonly COUNTRY_NAME = 'US';
  public static readonly COUNTRY_ID = 233;
  public static readonly APP_LOCALE = 'en-US';
  public static readonly CURRENCY = 'USD';
  public static readonly REMOVED_STATES = ['UM-81', 'UM-84', 'UM-86', 'UM-67', 'UM-89', 'UM-71', 'UM-76', 'UM-95', 'UM', 'UM-79', 'AS', 'GU', 'MP', 'PR', 'VI'];
  public static readonly USER_TYPE_LABEL = ['BX Super Admin', 'BX Admin', 'BX Content Admin', 'Account Admin', 'Program Admin', 'Session Admin', 'Staff'];
  public static readonly ROLE_TYPE_SUPER_ADMIN = 1;
  public static readonly ROLE_TYPE_BX_ADMIN = 2;
  public static readonly ROLE_TYPE_BX_CONTENT_ADMIN = 3;
  public static readonly ROLE_TYPE_ACCOUNT_ADMIN = 4;
  public static readonly ROLE_TYPE_PROGRAM_ADMIN = 5;
  public static readonly ROLE_TYPE_SESSION_ADMIN = 6;
  public static readonly ROLE_TYPE_STAFF = 7;
  public static readonly ROLE_TYPE_GUARDIAN = 10;
  public static readonly NORMAL_USER_START_ID = 3;
  public static readonly NORMAL_USER_END_ID = 8;
  public static readonly APPLICATION_PUBLISHED_STATUS = 14;


  public static readonly LOGOUT_ERROR = 'Logout error:';
  public static readonly SUPER_ADMIN_USER = 'superadmin';
  public static readonly ADMIN_USER = 'admin';
  public static readonly REGULAR_USER = 'user';
  public static readonly LOGIN = 'login';
  public static readonly REGISTER = 'register';
  public static readonly CHANGE_PASSWORD = 'changePassword';
  public static readonly USERNAME = 'username';
  public static readonly SET_PASSWORD = 'SetPassword';
  public static readonly PASSWORD = 'password';
  public static readonly WELCOME = 'welcome';
  public static readonly PARTNER_HOME = 'partnerhome';
  public static readonly UNASSIGNESITE = 'unassignsite';
  public static readonly ACCOUNT = 'home';
  public static readonly CONFIGURE_PROGRAM = 'configureprogram';
  public static readonly REGISTER_PAGE_TOKEN_EXPIRED = '/?link=expired';
  public static readonly REGISTER_PAGE_IDENTIFIER = '&identifier=';
  public static readonly SETPASSWORD_PAGE_TOKEN_EXPIRED = '/?resetpassword=tokenExpired';
  public static readonly REG_PAGE_EXP = 'expired';
  public static readonly SET_PASS_PAGE_EXP = 'tokenExpired';
  public static readonly SET_PASS_PAGE_TOKEN_MSG = "You have already set your password, please login to continue or click 'Forgot Password' to set a new password.";

  public static readonly LOWERCASE_MSG = 'At least 1 lowercase letter';
  public static readonly CAPITAL_MSG = 'At least 1 capital letter';
  public static readonly TEN_CHARACTER_MSG = 'At least 10 characters and no more than 15 characters';
  public static readonly SPECIAL_CHAR_MSG = "At least 1 of these special characters (!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~)";
  public static readonly ONE_NUMBER = 'At least 1 numeric value';

  public static readonly DEFAULT_ROUTE = '/';
  public static readonly FORGET_PASSWORD = '/forgot-password';
  public static readonly EMAIL_SENT = '/email-sent';
  public static readonly RESENT_INVITE = '/resendInvite';
  public static readonly PROFILE_ROUTE = '/user/profile';

  public static readonly STRENGTH_COLORS_LIST = ['green', 'yellow', 'red'];
  public static readonly STRENGTH_FONTS_WEIGHT = ['Strong', 'Medium', 'Weak'];
  public static readonly STYLE_GREEN = 'green';
  public static readonly STYLE_RED = 'red';
  public static readonly STYLE_YELLOW = 'yellow';

  public static readonly STRONG = 'Strong';
  public static readonly MEDIUM = 'Medium';
  public static readonly WEAK = 'Weak';
  public static readonly TEXT = 'text';

  public static readonly HOUR = 24;
  public static readonly MINUTES = 60;
  public static readonly SECOND = 60;
  public static readonly MILISECOND = 1000;

  public static readonly LOGIN_SUCCESS = 'login success';
  public static readonly LOGIN_FAIL = 'login fail';
  public static readonly AUTH_TOKEN = 'authorization_token';

  public static readonly HIDDEN = 'hidden';
  public static readonly VISIBLE = 'visible';
  public static readonly TOOL_TIP = 'tooltip';
  public static readonly TOOL_TIP_CLOSE = 'tooltip-close';

  public static readonly TRUE: boolean = true;
  public static readonly FALSE: boolean = false;
  public static readonly BLANK: string = '';

  public static readonly MINUSONE: number = -1;
  public static readonly ZERO: number = 0;
  public static readonly ONE: number = 1;
  public static readonly TWO: number = 2;
  public static readonly THREE: number = 3;
  public static readonly FOUR: number = 4;
  public static readonly FIVE: number = 5;

  public static readonly RESPONSE_200: number = 200;
  public static readonly RESPONSE_204: number = 204;
  public static readonly RESPONSE_404: number = 404;
  public static readonly RESPONSE_401: number = 401;
  public static readonly USER_ALREADY_REGISTERED: string = 'Error_UserAlreadyRegistered';
  public static readonly ERROR_DUPLICATE_EMAIL: string = 'Error_DuplicateEmail';
  public static readonly ERROR_SELECTED_ACCOUNT_ADMIN: string = 'Error_SelectedAccountInactive';
  public static readonly ERROR_SELECTED_PROGRAM_ADMIN: string = 'Error_SelectedProgramInactive';
  public static readonly ERROR_SELECTED_SESSION_ADMIN: string = 'Error_SelectedSiteInactive';
  public static readonly ERROR_PASSWORD_UPDATE: string = 'Error_PasswordUpdate';

  public static readonly RESPONSE_400: number = 400;
  public static readonly RESPONSE_406: number = 406;
  public static readonly RESPONSE_500: number = 500;
  public static readonly RESPONSE_409: number = 409;
  public static readonly EVENT_CLOSE: string = 'close';
  public static readonly EVENT_CLICK: string = 'click';

  public static readonly USER_ID: string = 'user_id';
  public static readonly PHONE_NO: string = 'Phone number (XXX) XXX-XXXX';

  public static readonly KEY_8: number = 8;
  public static readonly KEY_9: number = 9;
  public static readonly KEY_13: number = 13;
  public static readonly KEY_35: number = 35;
  public static readonly KEY_36: number = 36;
  public static readonly KEY_41: number = 41;
  public static readonly KEY_46: number = 46;
  public static readonly KEY_48: number = 48;
  public static readonly KEY_57: number = 57;
  public static readonly KEY_65: number = 65;
  public static readonly KEY_67: number = 67;
  public static readonly KEY_68: number = 68;
  public static readonly KEY_86: number = 86;
  public static readonly KEY_88: number = 88;
  public static readonly KEY_90: number = 90;
  public static readonly KEY_96: number = 96;
  public static readonly KEY_105: number = 105;
  public static readonly MOBLIE_HEIGHT_SIXNINE: number = 69;
  public static readonly MOBLIE_HEIGHT_TWOFOURTTWO: number = 242;

  public static readonly ENTER_PASS: string = 'enter-pass';
  public static readonly OLD_PASS: string = 'old-pass';
  public static readonly UKVISIBLE: string = 'uk-visible';
  public static readonly UKHIDDEN: string = 'uk-hidden';
  public static readonly PROFILE: string = 'profile';
  public static readonly AUTH_DATA: string = 'auth-data';

  public static readonly DASHBOARD = 'home';

  public static readonly NAV_DECIDER = [
    {
      roleType: 7,
      background: '',
      baseUrl: '',
      navView: [
        {
          title: 'Program Planner',
          isNested: false,
          baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}planner`,
          image: 'programplannericon.svg',
          class: 'programplannericon',
          isSelected: false,
          dropdownClass: 'purple-theme'
        },
        {
          title: 'Scholars',
          isNested: true,
          route: '',
          image: 'scholars.svg',
          class: 'scholars',
          openStatus: false,
          isSelected: false,
          dropdownClass: 'green-list',
          nestedDrop: [
            {
              title: 'Scholar Roster',
              isNested: false,
              baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}roster`,
              isSelected: false
            },
            {
              title: 'Attendance',
              isNested: false,
              baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}attendance`,
              isSelected: false
            }
          ]
        },
        {
          title: 'Data Dashboard',
          isNested: false,
          baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}dashboard`,
          image: 'barchart.svg',
          class: 'programplannericon',
          isSelected: false,
          dropdownClass: 'purple-theme'
        },
        {
          title: 'Learning & Resources',
          isNested: false,
          route: 'navigateUrl',
          image: 'resources.svg',
          class: 'resources',
          isSelected: false,
          dropdownClass: 'blue-list',
        },
        {
          title: '',
          isNested: true,
          route: '',
          image: 'user.svg',
          class: 'profile',
          openStatus: false,
          isSelected: true,
          dropdownClass: 'bright-blue',
          floatRight: true,
          profile: true,
          width: { minWidth: '200px', maxWidth: '300px', display: 'flex', justifyContent: 'flex-end' },
          hover: false,
          nestedDrop: [
            {
              title: 'My Profile',
              isNested: false,
              route: '/user/profile',
              isSelected: false,
            },
            {
              title: 'Staff Roster',
              isNested: false,
              baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}staffroster`,
              isSelected: false
            },
            {
              title: 'Help Center',
              isNested: false,
              route: '',
              isSelected: false,
              id: 3,
              callback: 'navigateUrl'
            },
            {
              title: 'Logout',
              isNested: false,
              route: '',
              isSelected: false,
              callback: 'logout',
              removeForMobile: true,
              changableBgBorder: true,
            }]
        }

      ]
    },
    {
      roleType: 6,
      background: '',
      baseUrl: '',
      navView: [
        {
          title: 'Program Planner',
          isNested: false,
          baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}planner`,
          image: 'programplannericon.svg',
          class: 'programplannericon',
          isSelected: false,
          dropdownClass: 'purple-theme'
        },
        {
          title: 'Scholars',
          isNested: true,
          route: '',
          image: 'scholars.svg',
          class: 'scholars',
          openStatus: false,
          isSelected: false,
          dropdownClass: 'green-list',
          nestedDrop: [
            {
              title: 'Scholar Roster',
              isNested: false,
              baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}roster`,
              isSelected: false
            },
            {
              title: 'Attendance',
              isNested: false,
              baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}attendance`,
              isSelected: false
            }
          ]
        },
        {
          title: 'Data Dashboard',
          isNested: false,
          baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}dashboard`,
          image: 'barchart.svg',
          class: 'programplannericon',
          isSelected: false,
          dropdownClass: 'purple-theme'
        },
        {

          title: 'Learning & Resources',
          isNested: false,
          route: 'navigateUrl',
          image: 'resources.svg',
          class: 'resources',
          isSelected: false,
          dropdownClass: 'blue-list',
        },
        {
          title: '',
          isNested: true,
          route: '',
          image: 'user.svg',
          class: 'profile',
          openStatus: false,
          isSelected: true,
          dropdownClass: 'bright-blue',
          floatRight: true,
          profile: true,
          width: { minWidth: '200px', maxWidth: '300px', display: 'flex', justifyContent: 'flex-end' },
          hover: false,
          nestedDrop: [
            {
              title: 'My Profile',
              isNested: false,
              route: '/user/profile',
              isSelected: false,
            },
            {
              title: 'Manage Program',
              isNested: false,
              baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}manageprogram`,
              isSelected: false
            },
            {
              title: 'Help Center',
              isNested: false,
              route: '',
              id: 3,
              callback: 'navigateUrl'
            },
            {
              title: 'Logout',
              isNested: false,
              route: '',
              isSelected: false,
              callback: 'logout',
              removeForMobile: true,
              changableBgBorder: true,
            }]
        }
      ]
    },
    {
      roleType: 5,
      background: '',
      baseUrl: '',
      navView: [
        {
          title: 'Program Planner',
          isNested: false,
          baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}planner`,
          image: 'programplannericon.svg',
          class: 'programplannericon',
          isSelected: false,
          dropdownClass: 'purple-theme'
        },
        {
          title: 'Data Dashboard',
          isNested: false,
          baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}dashboard`,
          image: 'barchart.svg',
          class: 'programplannericon',
          isSelected: false,
          dropdownClass: 'purple-theme'
        },
        {
          title: 'Learning & Resources',
          isNested: false,
          route: 'navigateUrl',
          image: 'resources.svg',
          class: 'resources',
          isSelected: false,
          dropdownClass: 'blue-list',
        },
        {
          title: '',
          isNested: true,
          route: '',
          image: 'user.svg',
          class: 'profile',
          openStatus: false,
          isSelected: true,
          dropdownClass: 'bright-blue',
          floatRight: true,
          profile: true,
          width: { minWidth: '200px', maxWidth: '300x', display: 'flex', justifyContent: 'flex-end' },
          hover: false,
          nestedDrop: [
            {
              title: 'My Profile',
              isNested: false,
              route: '/user/profile',
              isSelected: false,
            },
            {
              title: 'Manage Program',
              isNested: false,
              baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}manageprogram`,
              isSelected: false
            },
            {
              title: 'Help Center',
              isNested: false,
              route: '',
              id: 3,
              callback: 'navigateUrl'
            },
            {
              title: 'Logout',
              isNested: false,
              route: '',
              isSelected: false,
              callback: 'logout',
              removeForMobile: true,
              changableBgBorder: true
            }]
        }
      ]
    },
    {
      roleType: 1,
      baseUrl: '',
      navView: [
        {
          title: 'Partner Accounts',
          isNested: false,
          baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}home`,
          image: 'homeicon.svg',
          class: 'homeicon',
          isSelected: false,
          dropdownClass: 'voilet'
        },
        {
          title: 'Manage Users',
          isNested: false,
          baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}users`,
          image: 'managerusericon.svg',
          class: 'managerusericon',
          isSelected: false
        },
        {
          title: '',
          isNested: true,
          route: '',
          image: 'user.svg',
          class: 'profile',
          openStatus: false,
          isSelected: true,
          dropdownClass: 'bright-blue',
          floatRight: true,
          profile: true,
          width: { minWidth: '200px', maxWidth: '300px', display: 'flex', justifyContent: 'flex-end' },
          hover: false,
          nestedDrop: [
            {
              title: 'My Profile',
              isNested: false,
              route: '/user/profile',
              isSelected: false,
            },
            {
              title: 'Help Center',
              isNested: false,
              route: '',
              id: 3,
              callback: 'navigateUrl'
            },
            {
              title: 'Logout',
              isNested: false,
              route: '',
              isSelected: false,
              callback: 'logout',
              removeForMobile: true,
              changableBgBorder: true
            }]
        }
      ]
    },
    {
      roleType: 2,
      baseUrl: '',
      navView: [
        {
          title: 'Partner Accounts',
          isNested: false,
          baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}home`,
          image: 'homeicon.svg',
          class: 'homeicon',
          isSelected: false,
          dropdownClass: 'voilet'
        },
        {
          title: 'Manage Users',
          isNested: false,
          baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}users`,
          image: 'managerusericon.svg',
          class: 'managerusericon',
          isSelected: false
        },
        {
          title: '',
          isNested: true,
          route: '',
          image: 'user.svg',
          class: 'profile',
          openStatus: false,
          isSelected: true,
          dropdownClass: 'bright-blue',
          floatRight: true,
          profile: true,
          width: { minWidth: '200px', maxWidth: '300px', display: 'flex', justifyContent: 'flex-end' },
          hover: false,
          nestedDrop: [
            {
              title: 'My Profile',
              isNested: false,
              route: '/user/profile',
              isSelected: false,
            },
            {
              title: 'Help Center',
              isNested: false,
              route: '',
              id: 3,
              callback: 'navigateUrl'
            },
            {
              title: 'Logout',
              isNested: false,
              route: '',
              isSelected: false,
              callback: 'logout',
              removeForMobile: true,
              changableBgBorder: true
            }]
        }
      ]
    },
    {
      roleType: 4,
      baseUrl: '',
      navView: [
        {
          title: '',
          isNested: true,
          route: '',
          image: 'user.svg',
          class: 'profile',
          openStatus: false,
          isSelected: true,
          dropdownClass: 'bright-blue',
          floatRight: true,
          profile: true,
          width: { minWidth: '200px', maxWidth: '300px', display: 'flex', justifyContent: 'flex-end' },
          hover: false,
          nestedDrop: [
            {
              title: 'My Profile',
              isNested: false,
              route: '/user/profile',
              isSelected: false,
            },
            {
              title: 'Manage Users',
              isNested: false,
              baseUrl: `${process.env.VUE_APP_BASE_ADMIN_REDIRECT_URL}users`,
              isSelected: false,
            },
            {
              title: 'Manage Families',
              isNested: false,
              baseUrl: `${process.env.VUE_APP_BASE_ENROLLMENT_REDIRECT_URL}families/scholar`,
              isSelected: false,
            },
            {
              title: 'Enrollment Manager',
              isNested: false,
              baseUrl: `${process.env.VUE_APP_BASE_ENROLLMENT_REDIRECT_URL}enroll/submissions`,
              isSelected: false,
            },
            {
              title: 'Help Center',
              isNested: false,
              route: '',
              id: 3,
              callback: 'navigateUrl'
            },
            {
              title: 'Logout',
              isNested: false,
              route: '',
              isSelected: false,
              callback: 'logout',
              removeForMobile: true,
              changableBgBorder: true
            }
          ]
        }
      ]
    },
    {
      roleType: 0,
      navView: [
        {
          title: '',
          isNested: true,
          route: '',
          image: 'user.svg',
          class: 'profile',
          openStatus: false,
          isSelected: true,
          dropdownClass: 'bright-blue',
          floatRight: true,
          profile: true,
          width: { minWidth: '200px', maxWidth: '300px', display: 'flex', justifyContent: 'flex-end' },
          hover: false,
          nestedDrop: [
            {
              title: 'My Profile',
              isNested: false,
              route: '/user/profile',
              isSelected: false,
            },
            {
              title: 'Help Center',
              isNested: false,
              route: '',
              id: 3,
              callback: 'navigateUrl'
            },
            {
              title: 'Logout',
              isNested: false,
              route: '',
              isSelected: false,
              callback: 'logout',
              removeForMobile: true,
              changableBgBorder: true
            }]
        }
      ]
    },
  ];


  public static VALIDATE_CREATE_USER_FORM = {
    firstName: {
      name: 'firstName',
      error: false,
      errorText: 'First Name is required',
      alphaCharError: false,
      errorAlpha: 'Sorry, please use only alphabetic characters. Hyphens and apostrophes are also allowed.'
    },
    lastName: {
      name: 'lastName',
      error: false,
      errorText: 'Last Name is required',
      alphaCharError: false,
      errorAlpha: 'Sorry, please use only alphabetic characters. Hyphens and apostrophes are also allowed.'
    },
    email: {
      name: 'email',
      error: false,
      errorText: 'Email is required'
    }
  };
  public static readonly PRIVACY_POLICY = 'https://learn.arly.com/privacy-policy';
  public static readonly TERMS_URL = 'https://grow.bellxcel.org/terms-of-service-family';
  public static readonly IGNORE_NAV_ON_ROUTES: string[] = ['/configureprogram'];
  public static readonly CONTACT_US = 'https://www.bellxcel.org/connect-to-empower-your-school/contact-us';
  public static readonly COPPA_LINK = 'https://www.ftc.gov/tips-advice/business-center/guidance/complying-coppa-frequently-asked-questions-0';
  public static readonly ACCOUNT_ADMIN_PROGRAMS_LIST = { id: 0, userId: 0 };
  public static readonly ORDER_ASC_TEXT = 'asc';
  public static readonly ORDER_DESC_TEXT = 'desc';

  public static USER_CREATION = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    status: 1,
    inactiveDate: '',
    personalInvitationNote: '',
    userRoles: [{
      id: 0,
      roleId: 0,
      accountId: 0,
      programId: 0,
      siteId: 0,
      isPrimaryAccountAdmin: false,
    }],
    forgetPasswordGuid: '',
    roleName: 'Select System Role'
  };

  public static APPLICATION_DATA = {
    accountId: 0,
    createdAt: '',
    createdBy: 0,
    directions: '',
    elasticApplicationId: '',
    isPublish: false,
    isSubmit: false,
    name: '',
    programId: 0,
    programName: '',
    status: 0
  };

  public static ADD_NEW_CHILD = { id: '-1', value: 'I\'ll be adding a new child', siteIds: [-1], isTemporary: '' };

  public static SUBMIT_FORM_TEXT = 'submitForms';
  public static readonly APPLICATION_AUTO_SAVE_INTERVAL: number = 10000;
  public static readonly APPLICATON_AUTO_VALIDATE: number = 1000;
  public static GUARDIAN_FIRSTNAME = 'guardian_firstname';
  public static GUARDIAN_LASTNAME = 'guardian_lastname';
  public static GUARDIAN_ONE = 'guardian_1';
  public static GUARDIAN_EMAIL = 'guardian_email';
  public static SCHOLAR_BIRTHDATE = 'scholar_birthdate';
  public static SCHOLAR_AGE = 'scholar_age';
  public static PRIMARY_GUARDIAN = 'guardian_primary';

  public static readonly GUARDIAN_DELETE_STATUS: number = 3;
  public static readonly EMERGENCY_CONTACT_DELETE_STATUS: number = 3;
  public static readonly EMERGENCY_CONTACT_EMPTY_PHONE: string = '0000000000';
  public static readonly EMERGENCY_CONTACT_EMPTY_NAME: string = 'EMPTYSTATE';
  public static readonly GUARDIAN_EMPTY_MAIL: string = 'EMPTY@STATE.COM';

  public static readonly SCHOLAR_ENROLL_STATUS_PENDING = 6;
  public static readonly SCHOLAR_ENROLL_STATUS_ENROLLED = 10;
  public static readonly SCHOLAR_ENROLL_STATUS_WAITLIST = 11;
  public static readonly SCHOLAR_ENROLL_STATUS_DECLINED = 12;
  public static readonly FAQ_FAMILY = 'https://grow.bellxcel.org/faq-family';

  public static readonly EMERGENCY_CALLORDER = 'emergency_callorder';
  public static readonly DIVIDERLINE_TEXT = 'dividerLine';
  public static readonly TEXTAREALONGQUESTION_TEXT = 'textAreaLongQuestion';
  public static readonly FORMBUILDER_FIEDS_MAPPING_LIST = {
    'scholar_firstname': 'scholar_FirstName',
    'scholar_lastname': 'scholar_LastName',
    'scholar_age': 'scholar_Age',
    'scholar_birthdate': 'scholar_BirthDate',
    'scholar_phone': 'scholar_Phone',
    'scholar_phonetype': 'scholar_PhoneType',
    'scholar_address1': 'scholar_Address1',
    'scholar_address2': 'scholar_Address2',
    'scholar_city': 'scholar_City',
    'scholar_state': 'scholar_State',
    'scholar_zipcode': 'scholar_ZipCode',
    'emergency_firstname': 'emergency_FirstName',
    'emergency_lastname': 'emergency_LastName',
    'emergency_phone': 'emergency_Phone',
    'emergency_phonetype': 'emergency_Phonetype',

    'authorized_firstname': 'authorized_FirstName',
    'authorized_lastname': 'authorized_LastName',
    'authorized_phone': 'authorized_Phone',
    'authorized_phonetype': 'authorized_PhoneType',
    'authorized_fromdate': 'authorized_FromDate',
    'authorized_tilldate': 'authorized_TillDate',
    'authorized_relation': 'authorized_Relation',
    'guardian_firstname': 'guardian_FirstName',
    'guardian_lastname': 'guardian_LastName',
    'guardian_phone': 'guardian_Phone',
    'guardian_phonetype': 'guardian_PhoneType',
    'guardian_secondarytype': 'guardian_SecondaryType',
    'guardian_secondary_phone': 'guardian_Secondary_Phone',
    'guardian_address1': 'guardian_Address1',
    'guardian_address2': 'guardian_Address2',
    'guardian_city': 'guardian_City',
    'guardian_state': 'guardian_State',
    'guardian_zipcode': 'guardian_ZipCode'
  };
  public static readonly DUPLICATE_EMERGENCY_RECORD = 'Please assign a different person as an Emergency Contact. (Por favor asigne una persona diferente como Contacto de Emergencia.)';
  public static readonly DUPLICATE_GUARDIAN_RECORD = 'Please assign a different person as a Guardian. (Por favor asigne una persona diferente como Tutor.)';
  public static readonly DUPLICATE_AUTHORIZED_RECORD = 'Please assign a different person as an Authorized Pickup. (Por favor asigne una persona diferente como Recogida Autorizada.)';
  public static readonly DUPLICATE_GUARDIAN_EMAIL = 'Please assign a different Email. (Por favor asigne un Correo Electrónico diferente.)';

  public static readonly FORM_BUILDER_FIELD_RULES = {
    'guardian_address1': { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' },
    'guardian_city': { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' },
    'guardian_state': { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' },
    'guardian_zipcode': { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
  };

  public static readonly FORM_INPUT_CHILD_FIRSTNAME = 'scholar_firstname';
  public static readonly FORM_INPUT_CHILD_LASTNAME = 'scholar_lastname';
  public static readonly FORM_INPUT_CHILD_BIRTHDATE = 'scholar_birthdate';

  public static readonly STYLE = {
    COLOR: {

      BACKGROUND_100: '#FCFAF5',
      BACKGROUND_200: '#F8F1D8',
      BACKGROUND_300: '#F1E4B2',

      PRIMARY_100: '#EEEFE9',
      PRIMARY_700: '#546122',
      PRIMARY_800: '#3C441D',
      PRIMARY_900: '#2A3014',

      BLUE_100: '#E1F6F6',
      BLUE_500: '#34ABAF',
      BLUE_700: '#00797D',
      BLUE_800: '#00494B',
      BLUE_900: '#002425',

      NEUTRAL_100: '#FFFFFF',
      NEUTRAL_200: '#F8F8F8',
      NEUTRAL_300: '#F2F2F2',
      NEUTRAL_500: '#D0D0D0',
      NEUTRAL_600: '#767676',
      NEUTRAL_700: '#585858',
      NEUTRAL_900: '#2B2B2B',

      SUCCESS_100: '#E8FCEE',
      SUCCESS_700: '#088732',
      SUCCESS_800: '#047228',
      SUCCESS_900: '#066024',

      WARNING_100: '#FFF8EB',
      WARNING_700: '#B25E09',
      WARNING_800: '#96530F',
      WARNING_900: '#80460D',

      DANGER_100: '#FEF1F2',
      DANGER_700: '#DA2030',
      DANGER_800: '#BA2532',
      DANGER_900: '#981B25'
    },
    FONT: {
      FAMILY: 'Montserrat, sans-serif',
      WEIGHT: {
        HEADLINE_LIGHT_WEIGHT: '400',
        HEADLINE_HEAVY_WEIGHT: '700',

        PARAGRAPH_LIGHT_WEIGHT: '400',
        PARAGRAPH_HEAVY_WEIGHT: '600',

        BUTTON_100_WEIGHT: '600',
        BUTTON_200_WEIGHT: '600',

        LABEL_100_WEIGHT: '600',
        LABEL_200_WEIGHT: '600',
        LABEL_300_WEIGHT: '600',
        LABEL_400_WEIGHT: '600',
      },
      SIZE: {
        HEADLINE_100_LIGHT_SIZE: '36px',
        HEADLINE_200_LIGHT_SIZE: '32px',
        HEADLINE_300_LIGHT_SIZE: '24px',
        HEADLINE_400_LIGHT_SIZE: '20px',


        PARAGRAPH_100_LIGHT_SIZE: '18px',
        PARAGRAPH_200_LIGHT_SIZE: '16px',
        PARAGRAPH_300_LIGHT_SIZE: '14px',
        PARAGRAPH_400_LIGHT_SIZE: '12px',
        PARAGRAPH_500_LIGHT_SIZE: '10px',

        BUTTON_100_SIZE: '16px',
        BUTTON_200_SIZE: '12px',

        LABEL_100_SIZE: '16px',
        LABEL_200_SIZE: '14px',
        LABEL_300_SIZE: '12px',
        LABEL_400_SIZE: '10px'
      }
    }
  };
}